import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { Link, useParams, useNavigate } from "react-router-dom";
import AddVehicleTypeModal from "../components/addVehicleTypeModal";
import EditVehicleTypeModal from "../components/editVehicleTypeModal";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_Main_Entry = () => {
useAuthRedirect();
    const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [formData, setFormData] = useState({ sa: ""});
  const [subAssembly, setSubAssembly] = useState([])
  const [subFullAssembly, setSubFullAssembly] = useState([])

   const canView  = hasPermission("Vehicle Type Maintenance", "view");
        const canEntry = hasPermission("Vehicle Type Maintenance", "entry");
        const canEdit  = hasPermission("Vehicle Type Maintenance", "edit");
        const canDel   = hasPermission("Vehicle Type Maintenance", "del");
   


  useEffect(() => {
  const fetchSA = async () => {
    try {
      // Show loading alert
      Swal.fire({
        title: "Loading...",
        text: "Fetching Sub assembly. Please wait...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/get_subAssemblyList?id=${id}`
      );
setSubAssembly(response.data.saList || []);
      // Close the loading alert after data is set
      Swal.close();

    } catch (error) {
      Swal.close();
      console.error("Error fetching record:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to fetch vehicle details.",
        icon: "error",
      });
    }
  };

  fetchSA();
}, [id]);

  useEffect(() => {
    const fetchFullSA = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_subAssemblyFullList`);
        setSubFullAssembly(response.data.saFullList || []);
      } catch (error) {
        console.error("Error fetch:", error);
      }
    };
    fetchFullSA();
  }, []);



  useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/vehicleType_main_entry/${id}`);
      setData(response.data.subassemblys);
      setFilteredData(response.data.subassemblys);
    } catch (error) {
      console.error("Error fetching subassemblys:", error);
    } finally {
      setLoading(false);
    }
  };
  fetchData();
}, []);

const handleCheckboxChange = (id) => {
    const numericId = Number(id); // ensure numeric
    setSelectedIds((prev) =>
      prev.includes(numericId)
        ? prev.filter((i) => i !== numericId)
        : [...prev, numericId]
    );
  };
    

  const handleBulkDelete = () => {
    if (selectedIds.length === 0) {
      Swal.fire("Warning", "No items selected for deletion.", "warning");
      return;
    }
  
    console.log("Selected IDs to delete:", selectedIds);
  
    Swal.fire({
      title: `Delete ${selectedIds.length} item(s)?`,
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete them!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
            Swal.fire({
        title: "Loading...",
        text: "Fetching Sub assembly. Please wait...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

          const deleteRequests = selectedIds.map((id) => {
            console.log(`Sending DELETE request for ID: ${id}`);
            return axios.delete(`https://rfs2.infraconsoft.net.in/api/vehicle_main_sub_delete/${id}`);
          });
  
          await Promise.all(deleteRequests);
  
          // Remove from UI
          const updatedData = data.filter((item) => !selectedIds.includes(item.fld_id));
          setData(updatedData);
          setFilteredData(updatedData);
          setSelectedIds([]);
  
          Swal.fire("Deleted!", "Selected records have been deleted.", "success");
          window.location.reload();
        } catch (error) {
          console.error("Bulk delete error:", error);
          if (error.response) {
            console.error("Server response:", error.response.data);
          }
          Swal.fire("Error", "Failed to delete selected records.", "error");
        }
      }
    });
  };

  const openAddModal = () => {
    setIsAddModalOpen(true);
  };

  const closeAddModal = () => {
    setIsAddModalOpen(false);
  };

   const [isEditModalOpen, setIsEditModalOpen] = useState(false);
      const [editFormData, setEditFormData] = useState({ sa: "", subId: "" });
      
      const openEditModal = (item) => {
          setEditFormData({  subAssembly: item.fld_subassembly, subId: item.fld_subid, partNo: item.fld_PartNumber, desc: item.fld_Descriptions,
          spec: item.fld_Specification, qty: item.fld_Qty, usage: item.fld_UsageLimit, mainId : item.fld_id });
          setIsEditModalOpen(true);
      };
      
      const closeEditModal = () => {
          setIsEditModalOpen(false);
      };
    
  


  
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.fld_Descriptions || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };
  


  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

   if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                              <h2 className="add-txt">Vehicle Type Maintenance - Entry</h2>
                              <Link to={`/vehicle_type_maintenance_listing`}><p className="back-button"><i className="fa-solid fa-backward"></i> Back</p></Link>
                              </div>
          <Time />
        </section>


        {/* Add New Button */}
        {canEntry && (
       <div className="add-new-container">
        <button className="add-new-btn" onClick={() => openAddModal()}>
              <i className="fa-solid fa-plus" ></i> Add New
            </button>
        </div>
        )}

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by Description"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Descriptions</th>
                <th>Part Number/Grade</th>
                <th>Specification</th>
                <th>Qty</th>
                <th>Usage Limit</th>
                {canEdit && (
                <th>Edit</th>
                )}
                {canDel && (
                <th>
      <button onClick={handleBulkDelete} className="btn btn-danger btn-sm ms-2">
        Delete
      </button>
    </th>
                )}
              </tr>
            </thead>
            <tbody>
  {loading ? (
    <tr>
      <td colSpan="8" className="loading-text">Loading data, please wait...</td>
    </tr>
  ) : currentData.length > 0 ? (
    // Grouping by fld_subassembly
    Object.entries(
      currentData.reduce((groups, item) => {
        const sub = item.fld_subassembly || "Unknown";
        if (!groups[sub]) groups[sub] = [];
        groups[sub].push(item);
        return groups;
      }, {})
    ).map(([subassembly, items]) => (
      <React.Fragment key={subassembly}>
        <tr>
          <td colSpan="8" className="subassembly-heading">
            <strong>Sub Assembly: {subassembly}</strong>
          </td>
        </tr>
        {items.map((item, index) => (
          <tr key={item.fld_subid}>
            <td>{index + 1}</td>
            <td>{item.fld_Descriptions}</td>
            <td>{item.fld_PartNumber}</td>
            <td>{item.fld_Specification}</td>
            <td>{item.fld_Qty}</td>
            <td>{item.fld_UsageLimit}</td>
            {canEdit && (
            <td>
                      <Link onClick={() => openEditModal(item)} style={{color : "#030d68", fontWeight: "bold", cursor: "pointer"}}>
                        Edit
                      </Link>
                    </td>
            )}
            {canDel && (
            <td>
              <input
                type="checkbox"
                checked={selectedIds.includes(Number(item.fld_id))}
                onChange={() => handleCheckboxChange(item.fld_id)}
              />
            </td>
            )}
          </tr>
        ))}
      </React.Fragment>
    ))
  ) : (
    <tr>
      <td colSpan="8">No Data Available</td>
    </tr>
  )}
</tbody>


          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
      <AddVehicleTypeModal isAddOpen={isAddModalOpen} onAddClose={closeAddModal} formData={formData}  setFormData={setFormData} id={id} 
      sa={subAssembly}/>
      <EditVehicleTypeModal
    isOpen={isEditModalOpen}
    onClose={closeEditModal}
    editFormData={editFormData}
    setEditFormData={setEditFormData}
    id={id}
    sa={subFullAssembly}
/>
    </div>
  );
};


export default Vehicle_Main_Entry;
